/* eslint-disable @typescript-eslint/indent */
import { getBFFApiClient } from '@acp/feature/auth';
import { APIResponse, PortfolioProperty } from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';
import { PortfolioFilters } from './components/sidebar-options';

async function getProperties(
    params: PortfolioFilters,
    pageNumber: number,
    pageSize: number
) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queryParams: any = {
        query: params.query ?? '',
        facet: params.facets,
        service: params.services,
        serviceExclusivity: params.serviceExclusivity,
        page: pageNumber,
        'property-manager': [params.propertyManager],
        'page-size': pageSize,
        'new-access-issues': params.newAccessIssues ? '1' : '0',
    };

    const response = await getBFFApiClient().get<APIResponse<{
        total: number;
        items: PortfolioProperty[];
        unfilteredTotal: number;
    }>>('/v1/portfolio', {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        params: queryParams,
    });

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get properties: ${response.data.error}`);
    }

    return response.data.data;
}

export { getProperties };
